import { IAdFoxBannerContext } from '@cian/adfox';
import { Link } from '@cian/components';
import * as React from 'react';

const styles = require('./index.css');

export interface IMortgageOfferCardBanner {
  context: IAdFoxBannerContext;
}

export class MortgageOfferCardBanner extends React.Component<IMortgageOfferCardBanner> {
  public render() {
    const { context } = this.props;

    return (
      <div
        style={{ backgroundImage: `url(${context.backgroundImage})` }}
        className={styles['mortgage-offer-card-banner-wrapper']}
      >
        <Link href={context.reference} target="_blank">
          <p className={styles['text']}>{context.text}</p>
          <div className={styles['statistics']}>
            <div className={styles['statistics-item']}>
              <p className={styles['number']}>{context.num1}</p>
              <p className={styles['title']}>{context.label1}</p>
            </div>
            <div className={styles['statistics-item']}>
              <p className={styles['number']}>{context.num2}</p>
              <p className={styles['title']}>{context.label2}</p>
            </div>
            <div className={styles['statistics-item']}>
              <p className={styles['number']}>{context.num3}</p>
              <p className={styles['title']}>{context.label3}</p>
            </div>
          </div>
          <p className={styles['label']}>{context.label}</p>
        </Link>
      </div>
    );
  }
}
